<p-scrollPanel [style]="{width: '100%', height: getScrollHeight()}">
    <div class="p-fluid p-grid"
        style="padding-right: 15px;">
        <div class="p-field p-lg-5">
            <habil-label name="txtNome"
                label="Cliente">
                <input type="text"
                    name="txtNome"
                    pInputText
                    [(ngModel)]="registro.nome" />
            </habil-label>
        </div>
        <div class="p-field p-lg-3">
            <habil-label name="txtCnpj"
                label="CPF / CNPJ">
                <input type="text"
                    name="txtCnpj"
                    pInputText
                    [(ngModel)]="registro.cnpj" />
            </habil-label>
        </div>
        <div class="p-field p-lg-2">
            <habil-label name="ddSoftwares"
                label="Software">
                <p-dropdown name="ddSoftwares"
                    optionValue="value"
                    optionLabel="label"
                    [disabled]="true"
                    [(ngModel)]="licenca.software"
                    [options]="softwares">
                </p-dropdown>
            </habil-label>
        </div>
        <!-- <div class="p-field p-lg-2 p-col-align-center">
            <br>
            <p-checkbox [binary]="true" [(ngModel)]="obj.acessoGeral" label="Acesso geral"></p-checkbox>
        </div> -->
        <div class="p-field p-lg-3">
            <habil-label name="txtIp"
                label="IP">
                <input type="text"
                    name="txtIp"
                    pInputText
                    [(ngModel)]="obj.ip" />
            </habil-label>
        </div>
        <div class="p-field p-lg-2" *ngIf="obj.acessoGeral">
            <habil-label name="deVctoChave"
                label="Vencimento">
                <habil-date-edit name="deVctoChave"
                    [(ngModel)]="obj.expDate">
                </habil-date-edit>
            </habil-label>
        </div>
        <div class="p-field p-lg-2" *ngIf="obj.acessoGeral">
            <habil-label name="inNroLicencas" label="Licenças">
                <p-inputNumber inputId="inNroLicencas" [(ngModel)]="obj.nroLicencas">
                </p-inputNumber>
            </habil-label>
        </div>
        <div class="p-field p-col-12">
            <p-panel header="Módulos">
                <p-pickList sourceHeader="Módulos disponíveis"
                    (onMoveToSource)="onChangeModulos()"
                    (onMoveToTarget)="onChangeModulos()"
                    (onMoveAllToTarget)="onChangeModulos()"
                    (onMoveAllToSource)="onChangeModulos()"
                    targetHeader="Módulos Licenciados"
                    [responsive]="true"
                    [sourceStyle]="{'height':'250px'}"
                    [targetStyle]="{'height':'250px'}"
                    [source]="modulosDisponiveis"
                    [target]="licenca.modulosLicenciados"
                    [dragdrop]="true"
                    filterBy="descricaoModulo">
                    <ng-template let-modulo
                        pTemplate="item">
                        <div *ngIf="modulo">{{modulo.descricaoModulo}}</div>
                    </ng-template>
                </p-pickList>
            </p-panel>
        </div>
        <div class="p-field p-col-12">
            <p-panel header="Personalizar Rotinas"
                [toggleable]="true"
                [collapsed]="true">
                <p-pickList sourceHeader="Rotinas disponíveis"
                    targetHeader="Rotinas habilitadas"
                    [responsive]="true"
                    [sourceStyle]="{'height':'250px'}"
                    [targetStyle]="{'height':'250px'}"
                    [source]="rotinas"
                    [target]="rotinasComDescricao"
                    [dragdrop]="true"
                    filterBy="label">
                    <ng-template let-rotina
                        pTemplate="item">
                        <div *ngIf="rotina?.label">{{rotina.label}}</div>
                        <div *ngIf="!rotina?.label && rotina?.value">{{rotina.value}}</div>
                        <div *ngIf="!rotina?.label && !rotina?.value">{{rotina}}</div>
                    </ng-template>
                </p-pickList>
            </p-panel>
        </div>
    </div>
</p-scrollPanel>
<hr>
<div class="p-grid">
    <div class="p-col-2">
        <button pButton
            type="button"
            style="width: 100%;"
            class="p-button-outlined p-button-danger"
            label="Cancelar"
            icon="pi pi-times"
            (click)="cancelar()"></button>
    </div>
    <div class="p-col"></div>
    <div class="p-col-2">
        <button pButton
            type="button"
            style="width: 100%;"
            class="p-button-success"
            [loading]="loading"
            label="Salvar"
            icon="pi pi-check"
            (click)="salvar()"></button>
    </div>
</div>